import { render } from "./FormTestimonials.vue?vue&type=template&id=4ae9d11d"
import script from "./FormTestimonials.vue?vue&type=script&lang=js"
export * from "./FormTestimonials.vue?vue&type=script&lang=js"
script.render = render

export default script